import ReportsNotFoundSvgComponent from "../../assets/svg-components/not-found/reports";
import { NavLink } from "react-router-dom";
import "./index.scss";

export default function ReportsLogsNotfoundNoLink() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details config_vendors_not_found">
          {/* <img
            src="/images/page-not-found/reports.svg"
            className="not-found-image img-fluid not-found-image-reports"
          /> */}
          <div className="not-found-image img-fluid not-found-image-reports">
            <ReportsNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text no-data-found-text-reports">
            No reports are configured for the provided module.
          </p>
        </div>
      </div>
    </>
  );
}
